"use strict";
/*
 * Component that initializes both the Opinion lab module and the survey popup
 *
 * Note: Slight modifications have been made to original code from WalletExpNodeWeb to work in TS, but no functional
 * changes have been made other than how the `opinionLabVars` are initialized (see note below):
 * ConsumerWeb-R/walletexpnodeweb/blob/develop/public/js/components/UVLOpinionLab/opinionLabComponent.js
 */
Object.defineProperty(exports, "__esModule", { value: true });
var opinion_lab_popup_1 = require("./opinion-lab-popup");
var opinion_lab_1 = require("./opinion-lab");
/* eslint-disable */
function opinionLabComponent(props) {
    /**
     * Note: In WalletExpNodeWeb, this data was set to the `window` object and then read in each of these opinion lab
     * files. Instead of setting these to `window`, we instead just initialize the data here and then pass it to the
     * components that need it.
     *
     * Original variable initialization code:
     * ConsumerWeb-R/walletexpnodeweb/blob/develop/public/templates/components/UVLOpinionLab/opinionLab.dust
     * Component included in footer component:
     * ConsumerWeb-UI/component-header-footer/blob/master/components/footer/vx-footer.dust#L102-L107
     */
    var opinionLabVars = {
        siteCatalystPageName: '',
        siteCatalystC7: '',
        siteCatalystAccountNumber: '',
        feedback_link: props.content.footer ? props.content.footer.feedback : '',
        isPaymentFlow: false,
        isSiteRedirect: false,
        languageCode: props.locality.language,
        countryCode: props.locality.country,
        serverName: props.pageInfo.hostName,
        commentCardCmd: 'myCommand',
        accountNumber: props.user.encryptedAccountNumber,
        miniBrowser: false,
        sitefb_plus_icon: 'https://www.paypalobjects.com/en_US/i/scr/sm_333_oo.gif',
        rLogId: encodeURI(props.pageInfo.rlogId),
        showSitefbIcon: false,
        className: 'js_feedbackLink',
        optOut: false,
        page: 'main:settings:v2'
    };
    var opinionLab = opinion_lab_1.default(opinionLabVars), opinionLabPopup = opinion_lab_popup_1.default(opinionLabVars);
    /* Defines the referral URL - Verify */
    function paypalURL(pagename) {
        var paypalURL = 'https://'
            + opinionLabVars.countryCode
            + '.paypal.com/'
            + opinionLabVars.languageCode
            + '/00/'
            + encodeURI(pagename.replace(/\s|\//g, '_'))
            + '.page';
        return paypalURL;
    }
    function assignSiteCatalystVars() {
        if (typeof opinionLabVars.isSiteRedirect !== 'undefined' && typeof opinionLabVars.isPaymentFlow !== 'undefined') {
            if (typeof s !== 'undefined') {
                if (typeof s.pageName !== 'undefined') {
                    opinionLabVars.siteCatalystPageName = s.pageName;
                }
                if (typeof s.prop7 !== 'undefined') {
                    opinionLabVars.siteCatalystC7 = s.prop7 == "none" ? "Unknown" : s.prop7;
                }
                if (typeof s.prop5 !== 'undefined') {
                    opinionLabVars.siteCatalystAccountNumber = s.prop5;
                }
            }
            opinionLab.custom_var = updateCustomVars();
        }
    }
    function updateCustomVars() {
        var customVar = opinionLabVars.rLogId
            + '|' + opinionLabVars.siteCatalystC7
            + '|' + opinionLabVars.siteCatalystPageName
            + '|' + opinionLabVars.countryCode
            + '|' + opinionLabVars.languageCode
            + '|' + (opinionLabVars.accountNumber && opinionLabVars.accountNumber.length > 0 ? opinionLabVars.accountNumber : 'Unknown')
            + '|' + (opinionLabVars.siteCatalystAccountNumber && opinionLabVars.siteCatalystAccountNumber.length > 0 ?
            opinionLabVars.siteCatalystAccountNumber : 'Unknown')
            + (opinionLabVars.isSiteRedirect ? '' : '|Unknown|Unknown');
        return customVar;
    }
    function initialize() {
        var self = this;
        opinionLab.assignSiteCatalystVars = function () {
            assignSiteCatalystVars.call(self);
        };
        opinionLab._ht = paypalURL("'" + opinionLabVars.siteCatalystPageName + "'");
        opinionLab.custom_var = updateCustomVars();
        /* Opinion Lab URL under redirection through Paypal */
        if (opinionLabVars.isSiteRedirect) {
            opinionLab.baseurl = "https://"
                + opinionLabVars.serverName
                + '/cgi-bin/webscr?cmd=_handle-sf-redirect'
                + '&amp;account_number='
                + opinionLabVars.accountNumber;
        }
        if (opinionLabVars.isPaymentFlow) {
            opinionLab.url_var = "https://"
                + opinionLabVars.serverName
                + '/cgi-bin/webscr?cmd='
                + opinionLabVars.commentCardCmd
                + '&amp;account_number='
                + opinionLabVars.accountNumber;
            opinionLab.baseurl += "&amp;url_var=https://"
                + opinionLabVars.serverName
                + "/cgi-bin/webscr?cmd=cmd$"
                + opinionLabVars.commentCardCmd
                + "|account_number$"
                + opinionLabVars.accountNumber;
        }
    }
    if (opinionLabVars && typeof opinionLabVars.isSiteRedirect !== 'undefined' && typeof opinionLabVars.isPaymentFlow !== 'undefined') {
        if (opinionLabVars.miniBrowser) {
            opinionLab.Mini_O_GoT(opinionLabVars.feedback_link, opinionLabVars.isSiteRedirect);
        }
        else {
            if (opinionLabVars.isSiteRedirect) {
                opinionLab.PP_O_GoT(opinionLabVars.feedback_link);
            }
            else {
                opinionLab.O_GoT(opinionLabVars.feedback_link);
            }
        }
        initialize();
        if (opinionLabVars.isPaymentFlow) {
            var ppbce = void 0;
            if (opinionLabVars.isSiteRedirect) {
                ppbce = new opinionLabPopup.OpinionLabOnCloseEvent('ppwebscr');
            }
            else {
                ppbce = new opinionLabPopup.OpinionLabOnCloseEvent();
            }
        }
    }
}
exports.default = opinionLabComponent;
;
